// setupHelmet.js
//
// Root cause of the "SEO head tags are silently dead" bug:
//
// react-helmet-async (v2) writes its managed <head> tags from inside a
// `requestAnimationFrame` callback. This is gated by the Helmet `defer`
// prop, which DEFAULTS TO TRUE. See the library's client commit path:
//
//   handleStateChangeOnClient(state):
//     if (state.defer) requestAnimationFrame(() => commitTagChanges(state))
//     else             commitTagChanges(state)   // synchronous
//
// Browsers suspend requestAnimationFrame in any non-painting context:
// hidden/background tabs (a link cmd/ctrl-clicked into a background tab),
// and JS-executing-but-non-compositing renderers. In those contexts the
// deferred callback never fires, so the page-specific <title>, canonical,
// meta description, and OG/Twitter tags are never written and the page
// ships the bare defaults from public/index.html. Foreground human
// browsers eventually paint and fire the rAF, which is why the bug is
// invisible in ordinary manual testing but real for the crawler /
// background-tab paths that SEO pages exist to serve. (Classic
// react-helmet has the identical rAF-defer behavior.)
//
// Fix: force `defer: false` so every Helmet commits its tags synchronously
// during React's render/commit, independent of paint. This is the
// library-sanctioned escape hatch (the `defer` prop) applied globally so
// no individual page has to remember it. Helmet is a class component, so
// mutating defaultProps here (before the first Helmet renders) is
// reliable — React reads type.defaultProps at element creation.
//
// Import this module for its side effect at the very top of src/index.js,
// before the app renders.
import { Helmet } from 'react-helmet-async';

Helmet.defaultProps = {
  ...Helmet.defaultProps,
  defer: false,
};
